var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cascadeResourcePage"},[_c('cascadePage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }